
import { useMemo } from 'react';
import useClassificationLabelHook from '../hooks/useClassificationLabelHook'; // Use default import
const ClassificationLeft = (props) => {
    const {
        unstructuredImages,
        selectedImages,
        dragOver,
        activeDragClass,
        selectedImage,
        setShowDeleteButton,
        showDeleteButton,
        isUploading,
        uploadProgress,
        totalUploads,
        completedUploads,
        handlers
    } = useClassificationLabelHook();
    const { fileInputRef } = props;

    // Selection order for the badges. Built once per selection change: reading it
    // per tile with Array.from(...).indexOf(...) is O(n) inside an O(n) map, and a
    // Ctrl+A over a few hundred frames made that cost visible on every render.
    const selectionOrder = useMemo(() => {
        const order = new Map();
        let n = 1;
        selectedImages?.forEach((id) => order.set(id, n++));
        return order;
    }, [selectedImages]);

    return (
        <>
            <div
                className={`unstructured-section ${dragOver && activeDragClass === null ? 'drag-over' : ''}`}
                onDragOver={(e) => handlers.handleDragOver(e, null)}
                onDragLeave={handlers.handleDragLeave}
                onDrop={(e) => handlers.handleDrop(e, null)}
            >
                
                <div className="upload-options">
                    <label
                        htmlFor="unstructured-file-upload"
                        className="btn-primary upload-button"
                        onClick={() => fileInputRef.current = 'unstructured'}
                    >
                        Upload Images
                    </label>
                    <input
                        id="unstructured-file-upload"
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => handlers.handleFileInput(e, null)}
                        style={{ display: 'none' }}
                    />
                    <p>or drag and drop <b className="text-primary"> UNSTRUCTURED </b> images here</p>
                    <p className="selection-hint">
                        Click to preview · <b>Ctrl</b>+click to pick several ·
                        <b> Shift</b>+click for a range · <b>Ctrl</b>+<b>A</b> selects all ·
                        drag the selection onto a class
                    </p>
                </div>

                <div className="image-grid" style={{ maxHeight: 'calc(100% - 140px)' }}>
                     {isUploading && (
                    <div className="upload-progress-overlay">
                        <div className="upload-progress-container">
                        <h3 style={{color:"black"}}>Uploading Images</h3>
                        <div className="progress-bar">
                            <div 
                            className="progress-fill" 
                            style={{ width: `${uploadProgress}%` }}
                            ></div>
                        </div>
                        <p>{completedUploads} of {totalUploads} images processed</p>
                        </div>
                    </div>
)}
                    {unstructuredImages.map(image => (
                        
                        <div
                            key={image.id}
                            className={`image-item ${selectedImage?.id === image.id ? 'selected' : ''} ${selectedImages?.has(image.id) ? 'multi-selected' : ''}`}
                            draggable
                            onDragStart={(e) => handlers.handleImageDragStart(e, image)}
                            onClick={(e) => handlers.handleImageClick(image, e)}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                handlers.toggleImageSelection(image.id,e.shiftKey);
                            }}
                            onMouseEnter={() => setShowDeleteButton(image.id)}
                            onMouseLeave={() => setShowDeleteButton(null)}
                        >
                           <img
  src={image.url_display ?? image.url}
  alt={image.name || "Image"}
/>
                            <button
                                className={`delete-image-btn ${showDeleteButton === image.id ? 'visible' : ''}`}
                                onClick={(e) => handlers.deleteImage(image.id, e)}
                            >
                                ×
                            </button>
                            {selectionOrder.has(image.id) && (
                                <div className="selection-badge">{selectionOrder.get(image.id)}</div>
                            )}
                        </div>
                    ))}
                   
                </div>
            </div>
        </>
    );
};

export default ClassificationLeft;
